import { Merge } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgMerge = mkIcon(Merge);